// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1-6zo","copyright":"Footer_copyright__1rSXz"};